import * as React from 'react'
import {
  RIGHT_ARROW,
  LEFT_ARROW
} from './icon'


export class Right extends React.PureComponent<{
  isVisible: boolean
  count?: number
  onClick: () => void
}> {
  render() {
    const {
      isVisible,
      count,
      onClick,
    } = this.props

    const numCount = count || 0

    return (
      <div className={'pager pager-right' + (isVisible ? '' : ' pager-hidden')}>
      <button
        className="pager-button"
        onClick={onClick}
      >
        <span className="pager-count">{numCount > 0 ? count : '+'}</span>
        {RIGHT_ARROW}
      </button>
    </div>
    )
  }
}


export class Left extends React.PureComponent<{
  isVisible: boolean
  count?: number
  onClick: () => void
}> {

  render() {
    const {
      isVisible,
      count,
      onClick,
    } = this.props

    const numCount = count || 0

    return (
      <div className={'pager pager-left' + (isVisible ? '' : ' pager-hidden')}>
        <button
          className="pager-button"
          onClick={onClick}
        >
          {LEFT_ARROW}
          <span className="pager-count">{numCount > 1 && count}</span>
        </button>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/comp/pager.tsx